import React from 'react';
import { ProductionShiftProps } from './ProductionShift.types';
import {
  MulticolorProgressBar
} from '../../../components/ProgressIndicators/MulticolorBar';
import {
  DataContainer,
  POProgressBar,
  ProductionValueContainer,
  StyledDivider,
  StyledLabel,
  StyledProductionContent,
  StyledProductionShift,
  StyledShiftValue,
} from './ProductionShift.styles';
import { AllieEllipsedText } from '../EllipsedText';
import { AllieCollapsibleCard } from '../CollapsibleCard';
import { AllieColors } from '../../../common/color.types';
import { getColorBasedOnThreshold } from '../../../common/utils';
import { AllieScalesIcon } from '../../../styling/icons/Icons';

export const ProductionShift: React.FC<ProductionShiftProps> = ({
  estimatedLabel,
  productionLabel,
  productionValue,
  progress,
  progressText,
  isMobile,
  isTablet,
  collapsibleTitle,
  redThreshold,
  greenThreshold,
  estimatedValue,
  height = '15px',
  style,
  fullWidth,
  showIcon,
  showDivider,
  isNonWorkingShift = false,
}) => {
  return (
    <AllieCollapsibleCard
      title={collapsibleTitle}
      isCollapsible={isMobile}
      initialState={true}
      style={style}
    >
      <StyledProductionShift isMobile={isMobile}>
        <StyledProductionContent isMobile={isMobile} isTablet={isTablet}>
          <ProductionValueContainer fullWidth={fullWidth}>
            {showIcon && (
              <div className="icon-container">
                <AllieScalesIcon />
              </div>
            )}
            <DataContainer fullWidth={fullWidth}>
              <StyledLabel color="neutral-60" type="body3">
                {productionLabel}
              </StyledLabel>
              <StyledShiftValue color="neutral-90" type="h4" weight={600}>
                {productionValue}
              </StyledShiftValue>
            </DataContainer>
          </ProductionValueContainer>

          {estimatedLabel && (
            <>
              <StyledDivider isMobile={isMobile} isTablet={isTablet} showDivider={showDivider} />
              <DataContainer fullWidth={fullWidth}>
                <StyledLabel color="neutral-60" type="body3">
                  {estimatedLabel}
                </StyledLabel>

                <StyledShiftValue weight={600} color="neutral-90" type="h4">
                  {estimatedValue}
                </StyledShiftValue>
              </DataContainer>
            </>
          )}
        </StyledProductionContent>
        <POProgressBar height={height}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 10px',
              height,
              position: 'absolute',
              width: '100%',
              zIndex: 1,
            }}
          >
            {!isNonWorkingShift && (
              <AllieEllipsedText
                textProps={{
                  type: 'body2',
                  color: `${progress && progress <= 0.65 ? 'black-90' : 'white'}`,
                  weight: 500,
                }}
                value={
                  progress !== undefined && progress > 0.1 && progressText
                    ? `${progressText}: ${Math.round((progress || 0) * 100)}%`
                    : ''
                }
                triggerId={'planned-production'}
                maxWidth={'auto'}
              />
            )}
          </div>
          <MulticolorProgressBar
            values={[
              {
                color:
                  redThreshold || greenThreshold
                    ? (getColorBasedOnThreshold(
                        (progress ?? 0) * 100,
                        redThreshold,
                        greenThreshold
                      ) as AllieColors)
                    : 'primary-60',

                value: (progress ?? 0) * 100,
              },
            ]}
            height={height}
            borderRadius={100}
            weightRemainingText={500}
            remainingText={
              !isNonWorkingShift && progress !== undefined && progress <= 0.1 && progressText
                ? `${progressText}: ${Math.round((progress || 0) * 100)}%`
                : undefined
            }
          />
        </POProgressBar>
      </StyledProductionShift>
    </AllieCollapsibleCard>
  );
};
